import { mapGetters, mapMutations } from 'vuex'
import { saveManufactureLocStorage } from '@/store/manufactures'

export default {
  computed: {
    ...mapGetters({
      manufacturesList: 'manufactures/manufacturesList'
    })
  },
  methods: {
    ...mapMutations({
      setSelectManufacture: 'manufactures/SET_SELECTED_MANUFACTURE'
    }),
    findManufacture(manufacture_id) {
      return this.manufacturesList.find(manufacture => manufacture.id === manufacture_id)
    },
    goMainPage(manufacture_id) {
      const manufacture = this.findManufacture(manufacture_id)
      if (manufacture) {
        this.setSelectManufacture(manufacture)
        this.$router.push({
          name: 'main'
        })
      }
    },
    onContextmenuOrder(manufacture_id) {
      const manufacture = this.findManufacture(manufacture_id)
      if (manufacture) {
        saveManufactureLocStorage(manufacture)
      }
    }
  }
}